/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { useForm } from "../hooks/useForm";
import { setCredentials } from "../redux/actions";
import { resetPassword} from "../api/api";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactComponent as Logo } from "../images/logoBlue.svg";
import { validateEmail } from "../utils/validate";
import { Scaffold } from "../Scaffold";
import LoadingSpinner from "../LoadingSpinner";
import { State } from "../redux/types";


export const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tokenPayload = useSelector((state: State) => state.enterCode);
  const email = useSelector((state: State) => state.forgotPassword);
  const [error, setError] = useState("");
  const [passwordValue, setPasswordValue] = useState<string>("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState<string>("");
  const [emailValid, setEmailValid] = useState(true);

  const onPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPasswordValue(e.target.value);
  };
  const onConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setConfirmPasswordValue(e.target.value);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    dispatch(setCredentials(null));
  }, [dispatch]);

  const initial = {
    medleyUserEmail: "",
    password: "",
  };

  const validate = () => {
    setEmailValid(validateEmail(passwordValue) === true || confirmPasswordValue === "");
    return "";
  };

  const submit = async () => {
    if (!passwordValue || !confirmPasswordValue) {
      setError("Please enter new password");
      return;
    }
    if (passwordValue !== confirmPasswordValue) {
      setError("Passwords do not match");
      return;
    }
    setIsLoading(true);
    try {
      const body = {
        medleyUserEmail:  email?.medleyUserEmail,
        token: tokenPayload?.token,
        password: passwordValue,
      };
      const response = await resetPassword(body);
      const dataObject = response as any;
      dispatch(setCredentials(dataObject));
      navigate("/");
    } catch (e) {
      const err = e as AxiosError;
      if (err.response?.status === 403) {
        setError("Please Connect To VPN/Or Contact Support ");
      } else if (err.response?.status === 400) {
        setError("Please Contact Support to Reset Password");
      } else if (err.response?.status === 401) {
        setError("Unable to Login Please Check Credentials");
      } else if (
        err.response?.status === 429 ||
        err.response?.status === 404 ||
        err.response?.status === 500
      ) {
        setError("An Error Occurred Please Contact Support");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const { onSubmit } = useForm({
    initial,
    validate,
    submit,
  });
  return (
    <Scaffold center>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Card
          sx={{ width: 400, boxShadow: "0 0 5px 2px #C5C6D0", padding: "30px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Logo
              style={{
                marginTop: "-30px",
                marginLeft: "40px",
              }}
            />
            <Typography
              variant="h5"
              textAlign="left"
            >
              Reset Password
            </Typography>
          </Box>
          <CardContent>
            <Box>
              <Stack spacing={2}>
                <form onSubmit={onSubmit}>
                  <Stack spacing={2}>
                    <TextField
                      onChange={onPasswordChange}
                      size="small"
                      id="outlined-basic"
                      variant="outlined"
                      type={"password"}
                      value={passwordValue}
                      label="Password"
                      error={emailValid !== true}
                      onBlur={validate}
                    />
                    <TextField
                      onChange={onConfirmPasswordChange}
                      size="small"
                      id="outlined-basic"
                      variant="outlined"
                      type={"password"}
                      value={confirmPasswordValue}
                      label="Password"
                      error={emailValid !== true}
                      onBlur={validate}
                    />

                    <Button
                      type="submit"
                      variant="contained"
                      onClick={onSubmit}
                      color="primary"
                      size="medium"
                      disabled={
                        Boolean(passwordValue === "" ||
                        confirmPasswordValue === "")
                      }
                    >
                      Reset Password
                    </Button>
                  </Stack>
                  {error && (
                    <Typography
                      marginTop="10px"
                      marginBottom="0px"
                      variant="body1"
                      color="red"
                      fontWeight="500"
                    >
                      {error}
                    </Typography>
                  )}
                </form>
              </Stack>
            </Box>
            <Button
              variant="text"
              color="primary"
              onClick={() => navigate("/")}
            >
              Back To Login
            </Button>
          </CardContent>
        </Card>
      )}
    </Scaffold>
  );
};
